const conditionHelper = ( key ) => {
    const conditions = JSON.parse( localStorage.getItem( 'conditions' ) );

    if ( !conditions ) return;

    return conditions[key];
}

export default conditionHelper;
